import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = { class: "bg-wallet" }
const _hoisted_3 = { class: "s11_mobile px-8 pt-5 pb-4" }
const _hoisted_4 = { class: "flex align-items-center gap-3" }
const _hoisted_5 = { class: "secondary-font text-8xl" }
const _hoisted_6 = { class: "flex gap-5 mt-2" }
const _hoisted_7 = {
  key: 0,
  class: "s9_mobile"
}
const _hoisted_8 = { class: "card-carte-light" }
const _hoisted_9 = { class: "card-carte-floating right-bottom" }
const _hoisted_10 = { class: "flex align-items-center gap-2" }
const _hoisted_11 = { class: "secondary-font text-5xl" }
const _hoisted_12 = { class: "flex-mobile gap-7" }
const _hoisted_13 = { class: "widget s6_mobile px-5 py-5 mb-5" }
const _hoisted_14 = { class: "secondary-font font-semibold text-4xl text-grey-900 my-5" }
const _hoisted_15 = {
  class: "h-35 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_16 = { class: "widget-floating px-4 py-0 text-lg flex-right" }
const _hoisted_17 = {
  class: "h-35 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_18 = { class: "widget-floating px-4 py-0 text-lg flex-right" }
const _hoisted_19 = {
  class: "widget s6_mobile px-5 py-5 mb-5",
  style: {"background":"linear-gradient(135deg, rgba(var(--primary-color-rgb), 0.9), rgba(var(--color-black-rgb), 0.9))"}
}
const _hoisted_20 = { class: "flex flex-col align-items-center gap-3" }
const _hoisted_21 = { class: "widget s8_mobile text-center px-5 pt-7 pb-5 mb-5" }
const _hoisted_22 = { class: "s20 flex align-items-center mb-4" }
const _hoisted_23 = { class: "s20 mt-2" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "s13 mt-2" }
const _hoisted_26 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_27 = { class: "secondary-font font-semibold text-sm text-grey-600 mb-2" }
const _hoisted_28 = {
  key: 0,
  class: "text-grey-600 mb-4"
}
const _hoisted_29 = {
  key: 0,
  class: "flex-center py-7"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "secondary-font font-bold mb-3" }, "Solde total", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.showBalance ? _ctx.formatAmount(_ctx.balance) : '*** ***'), 1),
          _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "secondary-font text-5xl mt-2" }, "F", -1)),
          _createElementVNode("div", {
            class: "mt-2 ml-2 cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showBalance = !_ctx.showBalance))
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("img", {
              src: "/public/icons/icon-eye-off.svg",
              class: "size-medium icon-black",
              alt: ""
            }, null, -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/front/wallet/utilisation",
            class: "btn-supra lg flex-center flex-col align-items-center active"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("div", { class: "btn-supra-show-set btn-supra-animate mb-3" }, [
                _createElementVNode("div", { class: "btn-supra-show px-2" }, [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-utilisation.svg",
                    class: "btn-supra-icon icon-white",
                    alt: ""
                  })
                ])
              ], -1),
              _createElementVNode("span", { class: "text-grey-700" }, "Utilisation", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/front/profil/ma-souscription",
            class: "btn-supra lg flex-center flex-col align-items-center"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "btn-supra-show-set btn-supra-animate mb-3" }, [
                _createElementVNode("div", { class: "btn-supra-show" }, [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-souscription.svg",
                    class: "btn-supra-icon icon-white",
                    alt: ""
                  })
                ])
              ], -1),
              _createElementVNode("span", { class: "text-grey-700" }, "Souscription", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/front/ma-carte",
            class: "btn-supra lg flex-center flex-col align-items-center hide-mobile"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("div", { class: "btn-supra-show-set btn-supra-animate mb-3" }, [
                _createElementVNode("div", { class: "btn-supra-show" }, [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-carte.svg",
                    class: "btn-supra-icon icon-white",
                    alt: ""
                  })
                ])
              ], -1),
              _createElementVNode("span", { class: "text-grey-700" }, "Carte", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/front/profil",
            class: "btn-supra lg flex-center flex-col align-items-center"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createElementVNode("div", { class: "btn-supra-show-set btn-supra-animate mb-3" }, [
                _createElementVNode("div", { class: "btn-supra-show" }, [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-profil.svg",
                    class: "btn-supra-icon icon-white",
                    alt: ""
                  })
                ])
              ], -1),
              _createElementVNode("span", { class: "text-grey-700" }, "Profil", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      (_ctx.defaultCarte)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("h6", { class: "secondary-font font-bold" }, "Solde utilisable", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.showBalance ? _ctx.formatAmount(_ctx.defaultCarte.solde) : '***'), 1),
                    _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "secondary-font text-3xl" }, "F", -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        src: "/public/icons/icon-eye-off.svg",
                        class: "size-medium icon-white",
                        alt: ""
                      })
                    ], -1))
                  ])
                ])
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("img", {
                src: "/public/images/carte_coop.png",
                class: "card-carte-img",
                alt: "Carte"
              }, null, -1))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex gap-4 align-items-center" }, [
          _createElementVNode("div", { class: "square-lg bg-black rounded-50 px-3 py-3 flex-center" }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-pouvoir.svg",
              class: "icon-white",
              width: "90%",
              alt: ""
            })
          ]),
          _createElementVNode("h4", { class: "secondary-font text-grey-800" }, "Mon prochain revolving")
        ], -1)),
        _createElementVNode("h1", _hoisted_14, _toDisplayString(_ctx.formatAmount(_ctx.prochainRevolving)) + " F ", 1),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.revolvingBloquePourcent) + "%", 1),
          _createElementVNode("div", {
            class: "h-100p flex align-items-center justify-content-left rounded-100 text-lg bg-color-1000 text-white",
            style: _normalizeStyle({ width: _ctx.revolvingBloquePourcent + '%' })
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("div", { class: "px-4" }, "Bloqué", -1)
          ]))], 4)
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "h-10 mb-1" }, null, -1)),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.revolvingUtilisePourcent) + "%", 1),
          _createElementVNode("div", {
            class: "h-100p flex align-items-center justify-content-left rounded-100 text-lg bg-blue text-white",
            style: _normalizeStyle({ width: _ctx.revolvingUtilisePourcent + '%' })
          }, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("div", { class: "px-4" }, "Utilisé", -1)
          ]))], 4)
        ]),
        _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"h-10 mb-1\" data-v-afbb6016></div><div class=\"h-35 rounded-100 position-relative\" style=\"width:100%;background-color:rgba(var(--color-black-rgb), 0.1);\" data-v-afbb6016><div class=\"widget-floating px-4 py-0 text-lg flex-right\" data-v-afbb6016>100%</div><div class=\"h-100p flex align-items-center justify-content-left rounded-100 text-lg bg-green-light\" style=\"width:100%;\" data-v-afbb6016><div class=\"px-4\" data-v-afbb6016>Total</div></div></div>", 2))
      ]),
      _createElementVNode("div", _hoisted_19, [
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "flex gap-4 align-items-center" }, [
          _createElementVNode("div", { class: "square-lg bg-white rounded-50 px-3 py-3 flex-center" }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-market.svg",
              class: "icon-black",
              width: "90%",
              alt: ""
            })
          ]),
          _createElementVNode("h4", { class: "secondary-font text-white" }, "Marketplace")
        ], -1)),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_router_link, { to: "/front/market" }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createElementVNode("h4", { class: "secondary-font text-white mt-5" }, "Découvrir le market", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_router_link, { to: "/front/profil/changer-pin" }, {
          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
            _createElementVNode("img", {
              src: "/public/icons/icon-securite-glossy.png",
              width: "30%",
              alt: ""
            }, null, -1),
            _createElementVNode("h4", { class: "secondary-font text-grey-800 mt-6 mb-2" }, "Sécurité", -1),
            _createElementVNode("p", { class: "text-lg line-height-1-5 text-grey-700 text-center" }, " Activez la double authentification pour sécuriser votre compte. ", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "h-10" }, null, -1)),
    _createElementVNode("div", _hoisted_22, [
      _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "s10 secondary-font gap-4 mt-2 text-grey-800" }, "Transactions", -1)),
      _createVNode(_component_router_link, {
        to: "/front/wallet/utilisation",
        class: "s10 text-right"
      }, {
        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
          _createElementVNode("h5", { class: "secondary-font text-primary-color" }, "+Plus", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_23, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentTransactions, (tx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tx.id,
          class: "flex gap-6 mb-4 cursor-pointer",
          onClick: ($event: any) => (_ctx.goToTransaction(tx.id))
        }, [
          _cache[22] || (_cache[22] = _createElementVNode("div", {
            class: "square-xl px-4 py-4",
            style: {"background-color":"rgba(0, 185, 172, 0.08)"}
          }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-trans-recharger.svg",
              width: "100%",
              class: "icon-neutral",
              alt: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("h6", _hoisted_26, _toDisplayString(tx.libelle), 1),
            _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.formatDateTransaction(tx.date)) + " - " + _toDisplayString(tx.reference), 1)
          ]),
          _createElementVNode("h5", {
            class: _normalizeClass(["s5 secondary-font text-right mt-2", tx.type === 'credit' ? 'text-green' : ''])
          }, _toDisplayString(tx.type === 'credit' ? '+' : '-') + " " + _toDisplayString(_ctx.formatAmount(tx.montant)) + " F ", 3)
        ], 8, _hoisted_24))
      }), 128)),
      (_ctx.recentTransactions.length === 0 && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, " Aucune transaction récente "))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [...(_cache[23] || (_cache[23] = [
          _createElementVNode("p", { class: "secondary-font text-grey-600" }, "Chargement...", -1)
        ]))]))
      : _createCommentVNode("", true),
    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "clear-both h-60" }, null, -1))
  ]))
}